import request from '@/utils/request'
// 抽奖活动接口
const url = '/api/lottery.Hbrb/'
/**
 * 活动信息
 * @param {array} params 请求参数
 */
export function reqLotteryInfo(params) {
  return request({
    url: url + 'info',
    method: 'get',
    params: params
  })
}

/**
 * 活动扩展信息
 * @param {array} params 请求参数
 */
export function reqLotteryExtend(params) {
  return request({
    url: url + 'extend',
    method: 'get',
    params: params
  })
}

/**
 * 活动扩展信息
 * @param {array} params 请求参数
 */
export function reqLink(params) {
  return request({
    url: url + 'link',
    method: 'get',
    params: params
  })
}

/**
 * 抽奖
 * @param {array} params 请求参数
 */
export function reqDraw(params) {
  return request({
    url: url + 'draw',
    method: 'post',
    params: params
  })
}

/**
 * 我的奖品
 * @param {array} params 请求参数
 */
export function reqMyprize(params) {
    return request({
        url: url + 'myPrizes',
        method: 'get',
        params: params
    })
}

/**
 * 领取奖品
 * @param {array} params 请求参数
 */
export function reqSubMyinfo(params) {
    return request({
        url: url + 'subMyinfo',
        method: 'get',
        params: params
    })
}
